export const CREATE_BUSINESS_PROFILE = "Create a business profile first"; 